module.exports = __webpack_public_path__ + "assets/img/da21faeb2154375632288853ede34da1.png";